// DARK THEME

export const DARK_COLOR = '#eeeeee'
export const DARK_BORDER_COLOR = '#111111'
export const DARK_BACKGROUND_COLOR = '#111111'
export const DARK_NEON = '#3AC9FF'
export const DARK_BACKGROUND_GRAY = '#2A2B44'
export const DARK = 'DARK'

export const DARK_THEME = {
  theme: DARK,
  backgroundColor: DARK_BACKGROUND_COLOR,
  borderColor: DARK_BORDER_COLOR,
  color: DARK_COLOR,
  neon: DARK_NEON,
  backgroundGray: DARK_BACKGROUND_GRAY
}

// DARK THEME
export const LIGHT = 'LIGHT'
export const LIGHT_COLOR = '#111111'
export const LIGHT_BORDER_COLOR = '#eeeeee'
export const LIGHT_BACKGROUND_COLOR = '#eeeeee'
export const LIGHT_NEON = '#3AC9FF'
export const LIGHT_BACKGROUND_GRAY = '#efefff'



export const LIGHT_THEME = {
  theme: LIGHT,
  backgroundColor: LIGHT_BACKGROUND_COLOR,
  borderColor: LIGHT_BORDER_COLOR,
  color: LIGHT_COLOR,
  neon: LIGHT_NEON,
  backgroundGray: LIGHT_BACKGROUND_GRAY
}
